// extracted by mini-css-extract-plugin
module.exports = {"blogs":"blogs___1m2ws","allblogs":"allblogs___1Bq1r"};
    if(module.hot) {
      // 1677682835867
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  